import { type ITimelineItem } from '@/types/INote';
import styles from './index.module.scss';

export default function TimelineItem ({
  data,
  onClick,
}: {
  data: ITimelineItem;
  onClick: (id: string) => void;
}) {
  const onClickHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    onClick(data.id);
  };

  return (
    <li className={styles['timeline-item']}>
      <a
        className={styles['timeline-item__link']}
        href={`#note-${data.id}`}
        onClick={(e) => onClickHandler(e)}
        rel='nofollow'
      >
        {data.title}
      </a>
    </li>
  );
}
